<template>
    <div style="width: 100vw; height: 100dvh; background-color: rgba(255,255,255, 0.5);"
        class="d-flex flex-column align-items-center justify-content-center">
        <img style="height: 50px" src="/logo/Gpuhub-logo-text.svg" />
        <div class="title text-center mt-2" style="font-size: 2rem">
            <strong v-html="$t('registerSuccess.welcomeTitle')"></strong>
        </div>
        <div class="content d-flex flex-column align-items-center justify-content-center font-size-85"
            style="text-align: center">
            <div class="mt-3 pl-3 pr-3" style="color: #555; border-radius: 50px;">
                <div class="mt-3" style="margin-left: 0.75rem; margin-right: 0.75rem">
                    <i18n v-if="emailAddress" path="registerSuccess.emailSentWithAddress" tag="span">
                        <template #email><strong>{{ emailAddress }}</strong></template>
                    </i18n>
                    <span v-else>{{ $t('registerSuccess.emailSentNoAddress') }}</span>
                </div>
                <div style="margin-left: 0.75rem; margin-right: 0.75rem" class="mb-3">
                    {{ $t('registerSuccess.activateAccountNote') }}
                </div>
                <input type="hidden"
                    id="email_address_registered"
                    name="email_address_registered"
                    :value="emailAddress"/>
            </div>
            <el-button @click="pushUrl('/login')" style="width: 10rem" class="mt-4" type="primary"
                round>
                {{ $t('registerSuccess.continueButton') }}
            </el-button>
            <iframe class="youtube mt-4" style="border-radius: 5px;" width="560" height="315"
                src="https://www.youtube.com/embed/W7RqCsuA5tc" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
</template> 

<style scoped>
@media only screen and (max-width: 576px) {
    .youtube {
        display: none !important;
    }

    .title {
        font-size: 1.5rem !important;
    }

    .content {
        font-size: 0.75rem !important;
    }
}
</style>

<script>
export default {
    computed: {
        emailAddress(){
            try{
                let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(this.$route.query.id) {
                    if(emailRegex.test(window.atob(this.$route.query.id))) return window.atob(this.$route.query.id);
                    else return null;
                }
                else return null;
            }
            catch{
                return null;
            }
        }
    },
    methods: {
        pushUrl(url) {
            window.location.href = url;
        }
    },
};
</script>